<div style="position: relative;" *ngIf="user">
  <patternlib-flyoutmenu useFlyoutGroups="true" [show]="showAvatarFlyout"  arrow-position="top" (lhFlyoutClosed)="showAvatarFlyout = false" [userName]="user.name" [userInfo]="user.info"
    [userInitials]="user.initials" top-position="15px" left-position="-100px" width="auto" name="flyoutmenu">
    <div slot="flyoutmenu-button" [ngClass]="{'demo-badge-wrapper' : user.isDemoUser}">
      <patternlib-avatar [initials]="user.initials" (click)="toggleAvatarFlyout()" >
      </patternlib-avatar>
      <div *ngIf="user?.isDemoUser" class="demo-badge">
          Demo
      </div>
    </div>
    <patternlib-grid slot="flyoutmenu-content" padding="10px 0 15px 0">
      <ng-content></ng-content>
    </patternlib-grid>
  </patternlib-flyoutmenu>
</div>

